// Action constants

const exportedObject= {
  OTP_SENT_REQUEST: 'OTP_SENT_REQUEST',
  OTP_SENT_SUCCESS: 'OTP_SENT_SUCCESS',
  OTP_SENT_FAILURE: 'OTP_SENT_FAILURE',
  
};
export default exportedObject;